// components
import { Container } from '@/components/Grid/Container';

//assets
import BlueYonderLogo from '@/public/images/logos/logo-blue_yonder.svg';
import E2OpenLogo from '@/public/images/logos/logo-e2open.svg';
import ManhattanBlackLogo from '@/public/images/logos/logo-manhattan_black.svg';
import MercuryGateLogo from '@/public/images/logos/logo-mercury_gate.svg';
import OracleLogo from '@/public/images/logos/logo-oracle.svg';

//styles
import {
  IconsWrapper,
  LogosWrapper,
  ImageWrapper,
  Title,
  Content,
} from './IconSection.styles';

export const IconSection = () => (
  <>
    <IconsWrapper>
      <Container>
        <Title>Open API integrations</Title>
        <Content>
          Our open API allows easy integration with TMS, WMS, ERP, or YMS
          systems, empowering you to automate tasks and centralize data across
          systems. Collaborating with trusted integration partners within the
          industry, we deliver robust integrations tailored to your needs.
          Leverage our API documentation to unlock the full potential of data
          sharing between your systems, including internal reporting systems
          like PowerBI or Tableau for data-driven decision making. Experience
          the power of Opendock’s open API integration and improve your
          warehouse operations today.
        </Content>

        <LogosWrapper>
          <ImageWrapper src="/images/warehouse/icons/avectous_logo.png" />
          <ImageWrapper src="/images/warehouse/icons/pulp_wms_logo.png" />
          <ImageWrapper src="/images/warehouse/icons/redwood_logo.png" />
          <ImageWrapper src="/images/warehouse/icons/rockfarm_logo.png" />
        </LogosWrapper>
      </Container>
    </IconsWrapper>
  </>
);
